import { Navigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { LoadingState } from './LoadingState'
import { Box, Heading, Text, VStack, Button } from '@chakra-ui/react'
import { AlertCircle } from 'lucide-react'
import { Link as RouterLink } from 'react-router-dom'

interface ProtectedExtranetRouteProps {
  children: React.ReactNode
}

/**
 * Protected route for Extranet (OWNER, COUNCIL_MEMBER only)
 */
export function ProtectedExtranetRoute({ children }: ProtectedExtranetRouteProps) {
  const { data: auth, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingState />
  }

  // Check authentication
  if (!auth?.session) {
    return <Navigate to="/app/extranet/login" replace />
  }

  // Check if user has extranet role (OWNER or COUNCIL_MEMBER)
  const hasExtranetRole = auth.residences.some((r) =>
    ['OWNER', 'COUNCIL_MEMBER'].includes(r.role)
  )

  if (!hasExtranetRole) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.50" p={8}>
        <VStack gap={6} maxW="md" textAlign="center">
          <Box
            p={4}
            bg="red.100"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <AlertCircle size={40} color="#e53e3e" />
          </Box>
          <Heading size="xl" color="gray.900">
            Accès refusé
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Vous n'avez pas accès à l'extranet copropriétaire.
          </Text>
          <Text color="gray.600" fontSize="sm">
            L'accès à cette zone est réservé aux copropriétaires.
          </Text>
          <VStack gap={3} w="full" pt={4}>
            <RouterLink to="/app/login" style={{ width: '100%' }}>
              <Button
                colorPalette="brand"
                size="lg"
                w="full"
              >
                Accéder à l'outil de gestion
              </Button>
            </RouterLink>
            <RouterLink to="/app/extranet/login" style={{ width: '100%' }}>
              <Button
                variant="outline"
                size="lg"
                w="full"
              >
                Retour à la connexion
              </Button>
            </RouterLink>
          </VStack>
        </VStack>
      </Box>
    )
  }

  return <>{children}</>
}
